"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _utils = require("../utils");

var _link = _interopRequireDefault(require("../../assets/Theme3Img/link.png"));

var _phone = _interopRequireDefault(require("../../assets/Theme3Img/phone.png"));

var _article = _interopRequireDefault(require("../../assets/Theme3Img/article.png"));

var _image = _interopRequireDefault(require("../../assets/Theme3Img/image.png"));

var _object = _interopRequireDefault(require("../../assets/Theme3Img/object.png"));

var _location = _interopRequireDefault(require("../../assets/Theme3Img/location.png"));

var _video = _interopRequireDefault(require("../../assets/Theme3Img/video.png"));

var _folder = _interopRequireDefault(require("../../assets/Theme3Img/folder.png"));

var _custom = _interopRequireDefault(require("../../assets/Theme3Img/custom.png"));

var _mini = _interopRequireDefault(require("../../assets/Theme3Img/mini.png"));

var _music = _interopRequireDefault(require("../../assets/Theme3Img/music.png"));

var _text = _interopRequireDefault(require("../../assets/Theme3Img/text.png"));

var _pano = _interopRequireDefault(require("../../assets/Theme3Img/pano.png"));

var _pdf = _interopRequireDefault(require("../../assets/Theme3Img/pdf.png"));

var _obj3d = _interopRequireDefault(require("../../assets/Theme3Img/obj3d.png"));

var _prev = _interopRequireDefault(require("../../assets/Theme3Img/prev.png"));

var _next = _interopRequireDefault(require("../../assets/Theme3Img/next.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(data, MEDIA_DOMAIN, PUBLIC_DOMAIN, urlSplicing) {
  if (urlSplicing === void 0) {
    urlSplicing = _utils._urlSplicing;
  }

  var iconUrl = data.iconMediaUrl;

  if (iconUrl && iconUrl !== "") {
    var DOMAIN = data.iconMediaId === 0 ? PUBLIC_DOMAIN : MEDIA_DOMAIN;
    return urlSplicing(iconUrl, DOMAIN, 160);
  } // 分


  if (data.type === 0) {
    return _folder["default"];
  } //   # 0:超链接 1:电话 2:导航 3:图文 4:文本 5:文章 6:音频 7:视频 8:环物 9:场景切换 10:无功能 11:自定义 12:小程序


  switch (data.children[0].code) {
    case 0:
      return _link["default"];

    case 1:
      return _phone["default"];

    case 2:
      return _location["default"];

    case 3:
      return _image["default"];

    case 4:
      return _text["default"];

    case 5:
      return _article["default"];

    case 6:
      return _music["default"];

    case 7:
      return _video["default"];

    case 8:
      return _object["default"];

    case 9:
      return _pano["default"];

    case 11:
      return _custom["default"];

    case 12:
      return _mini["default"];

    case 13:
      return _pdf["default"];

    case 14:
      return _obj3d["default"];

    case 15:
      return _prev["default"];

    case 16:
      return _next["default"];

    default:
      return null;
  }
};

exports["default"] = _default;
module.exports = exports.default;